import React, { useState, useContext } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import CheckoutService from "../../services/CheckoutService";
import { handleCheckoutError } from "../../utils/checkout";
import { ModalContext } from "../../context/ModalContext";
import { AuthContext } from "../../context/AuthContext";
import { Link, navigate } from "@reach/router";
import { cardStyle } from "./utils";

const StripeCreditCard = ({ element_id, discountCode }) => {
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [accept, setAccept] = useState(false);
  const elements = useElements();
  const stripe = useStripe();

  const { alert } = useContext(ModalContext);
  const { user } = useContext(AuthContext);

  const handleSuccess = (purchase_id) => {
    setProcessing(false);
    navigate(`/thankyou/${purchase_id}`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accept) {
      return alert(
        "Debes aceptar los términos y condiciones para poder comprar."
      );
    }
    setProcessing(true);
    const card = elements.getElement(CardElement);
    const payment_method = await stripe.createPaymentMethod({
      type: "card",
      card,
      billing_details: {
        email: user.email,
      },
    });
    CheckoutService.attempt(element_id, discountCode, payment_method)
      .then(async (res) => {
        const { clientSecret, purchase_id } = res.data;
        if (clientSecret) {
          const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
              card,
            },
          });
          if (payload.error) {
            handleCheckoutError(payload.error.message, alert);
          } else {
            handleSuccess(purchase_id);
          }
        } else {
          handleSuccess(purchase_id);
        }
      })
      .catch((error) => {
        setProcessing(false);
        handleCheckoutError(error, alert);
      });
  };

  const handleChange = async (event) => {
    setDisabled(event.empty || event.error);
  };

  return (
    <div className="container-fluid px-0">
      <form onSubmit={handleSubmit}>
        <h5 className="border-bottom pb-2 mb-3">Tarjeta de Crédito</h5>
        <CardElement
          id="card-element"
          options={cardStyle}
          className="form-control pt-2 my-2"
          onChange={handleChange}
        />
        <div className="container-fluid px-0 py-2 mb-2">
          <label>
            <input
              type="checkbox"
              checked={accept}
              className="d-inline-block me-2"
              onChange={() => setAccept(!accept)}
            />
            He leído y acepto todos los <Link to="/terminos-y-condiciones">términos y condiciones</Link> de uso de la plataforma de Latina at Home
          </label>
        </div>
        <button
          className="btn btn-success btn-checkout bold"
          disabled={processing || disabled}
        >
          {processing ? <div className="spinner-border"></div> : "Pagar Ahora"}
        </button>
      </form>
    </div>
  );
};

export default StripeCreditCard;
